import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as actions from 'redux/actions/settingActions';
import { Translate, I18n } from 'react-redux-i18n';
import { confirmDialog } from 'utils/confirmDialog';

const Reset = (props) => {
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);

  const canSubmit = password.trim().length > 0;

  const runReset = async () => {
    if (!props.user_id || busy || !canSubmit) {
      return;
    }
    setBusy(true);
    const result = await props.reset({
      id: props.user_id,
      password: password.trim(),
    }, props.token);
    setBusy(false);
    if (result?.success) {
      setPassword('');
    }
  };

  const handleReset = () => {
    if (!canSubmit) {
      return;
    }

    confirmDialog({
      title: I18n.t('reset_confirm_title'),
      message: I18n.t('reset_confirm_message'),
      onConfirm: () => runReset(),
      okLabel: I18n.t('reset'),
      cancelLabel: I18n.t('close'),
      variant: 'danger',
    });
  };

  return (
    <div className="settings-panel settings-panel--danger">
      <h3 className="settings-panel-title">
        <Translate value="reset" />
      </h3>
      <p className="settings-panel-subtitle">
        <Translate value="reset_all" />
      </p>
      <p className="settings-reset-warning">
        <Translate value="reset_warning" />
      </p>
      <div className="settings-panel-content">
        <div className="settings-reset-field">
          <label htmlFor="settings-reset-password">
            <Translate value="reset_password_prompt" />
          </label>
          <input
            id="settings-reset-password"
            name="password"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            disabled={busy}
          />
        </div>
        <button
          type="button"
          className="btn btn-danger"
          onClick={handleReset}
          disabled={busy || !props.user_id || !canSubmit}
        >
          {busy ? '...' : <Translate value="reset" />}
        </button>
      </div>
    </div>
  );
};

Reset.propTypes = {
  className: PropTypes.string,
};

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.token,
  };
}

const mapDispatchToProps = (dispatch) => ({
  reset: (params, token) => dispatch(actions.reset({ params, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Reset);
